import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  FormControl,
  TextField,
  Paper,
  Button,
  IconButton,
  Tooltip,
  Stack,
  useTheme,
  LinearProgress,
  Select,
  MenuItem,
  InputLabel,
  Checkbox,
  FormControlLabel,
  FormLabel,
  Grid,
  ListItemText,
  Chip,
  Backdrop,
} from "@mui/material";
import {
  dataGridHeaderFooterHeight,
  dataGridHeight,
  dataGridRowHeight,
  formGap,
} from "../../../ui-components/global/utils";
import {
  explorePostData,
  fetchApidata,
  postApidata,
  postApidatawol,
  getDeployment,
  postDeployment,
  invoiceExploreGetData,
  postData,
  resetTrackingData,
  empAttendance,
  Attendance,
  AttendanceProcess,
  timeSheet,
  timeSheetPostData,
  timeSheetreport,
  PSRreportpost,
  ProjectStatusReport,
  resetProjectStatusReport,
  resetPSRBarChart,
  ProjectStatusReportBarChart,
  ProductCosting,
  CostOverview,
  CostTrend,
  EmployeeOverrun,
} from "../../../store/reducers/Formapireducer";
import useMediaQuery from "@mui/material/useMediaQuery";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import {
  // DataGrid,
  GridToolbarContainer,
  // GridToolbarColumnsButton,
  // GridToolbarFilterButton,
  // GridToolbarExport,
  // GridToolbarDensitySelector,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { Formik, Field } from "formik";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { DataGrid } from "@mui/x-data-grid";
import { useProSidebar } from "react-pro-sidebar";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
//import TimeSheetPDF from "../pdf/TimeSheetPdf"
import TimeSheetPDF from "../../reports/TimeSheetPdf";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { tokens } from "../../../Theme";
import store from "../../../index";
import { LoadingButton } from "@mui/lab";
import { useDispatch } from "react-redux";
import { fetchExplorelitview } from "../../../store/reducers/Explorelitviewapireducer";
import EditIcon from "@mui/icons-material/Edit";
import { toast } from "react-hot-toast";
import {
  Employeeautocomplete,
  MultiFormikOptimizedAutocomplete,
  MultiFormikOptimizedselectAutocomplete,
  Productautocomplete,
} from "../../../ui-components/global/Autocomplete";



import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import PSRreport from "../../reports/PSRreport";
// import PSRreportPageBreak from "../../reports/PSRreportPageBreak";
import PSRreportPageBreak_v1 from "../../reports/PSRreportPageBreak_v1";
import { getConfig } from "../../../config";
import { FaFileExcel } from "react-icons/fa";

import { Pie, Bar, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Filler
} from "chart.js";
import CircularProgress from "@mui/material/CircularProgress";
import PSRreportPageBreakExcel from "../../reports/PSRreportPageBreakExcel";
import PSRreportExcel from "../../reports/PSRreportExcel";

ChartJS.register(
  ArcElement,
  ChartTooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Filler
);
const EditProjectStatusReport = () => {

  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const mode = params.Mode;
  const dispatch = useDispatch();
  const isManager = sessionStorage.getItem("isManager");
  console.log(isManager, "isManager");
  const EMPNAME = sessionStorage.getItem("EmpName");
  var recID = params.id;
  var accessID = params.accessID;
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const listViewData = useSelector((state) => state.listviewApi.rowData);
  const listViewColumn = useSelector((state) => state.listviewApi.columnData);
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  // const empAttendanceData = useSelector(
  //   (state) => state.formApi.empAttendanceData
  // );
  // console.log("empAttendanceData", empAttendanceData);
  // const { Month, Year } = location.state || {};

  // console.log(Month, "Received Month");
  // console.log(Year, "Received Year");
  const HeaderImg = sessionStorage.getItem("CompanyHeader");
  const FooterImg = sessionStorage.getItem("CompanyFooter");
  const config = getConfig();
  const baseurl1 = config.UAAM_URL;
  console.log("HeaderImg", HeaderImg, FooterImg);

  const PSRData = useSelector((state) => state.formApi.PSRData);
  const PSRempTaskData = useSelector((state) => state.formApi.PSRempTaskData);
  const PSRprojectTaskData = useSelector(
    (state) => state.formApi.PSRprojectTaskData,
  );
  const PSRLoading = useSelector((state) => state.formApi.PSRLoading);
  const pdfEnabled = PSRempTaskData.length > 0 || PSRprojectTaskData.length > 0;
  console.log("🚀 ~ EditProjectStatusReport ~ pdfEnabled :", pdfEnabled)
  // const trackingLoading = useSelector((state) => state.formApi.trackingLoading);

  const AttendanceData = useSelector((state) => state.formApi.timeSheetData);
  const projectName = useSelector((state) => state.formApi.projectName);
  const managerName = useSelector((state) => state.formApi.managerName);

  const companyID = sessionStorage.getItem("companyId");
  const getLoading = useSelector((state) => state.formApi.getLoading);
  const data = useSelector((state) => state.formApi.Data);
  const isLoading = useSelector((state) => state.formApi.loading);
  const [pageSize, setPageSize] = useState(15);
  const [page, setPage] = React.useState(0);
  const [page1, setPage1] = React.useState(0);
  const [page2, setPage2] = React.useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [show, setScreen] = React.useState("0");
  const [footerHeight, setFooterHeight] = useState(60);
  const [isReady, setIsReady] = useState(false);
  const EMPID = sessionStorage.getItem("EmpId");
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const colors = tokens(theme.palette.mode);
  const today = new Date();
  const formattedDate = today.toISOString().split("T")[0];
  const CompanyID = sessionStorage.getItem("companyId");

  console.log(formattedDate);
  const [selectedRow, setSelectedRow] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const [employeeURL, setEmployeeURL] = useState("");
  const [errorMsgData, setErrorMsgData] = useState(null);

  useEffect(() => {
    if (!FooterImg) return;

    const url = `${baseurl1}/uploads/images/${FooterImg}`;

    const img = new Image();
    img.src = url;

    img.onload = () => {
      const aspectRatio = img.height / img.width;

      const pageWidth = 842;
      const MAX_FOOTER_HEIGHT = 80; // 🔥 IMPORTANT

      const calculatedHeight = Math.min(
        pageWidth * aspectRatio,
        MAX_FOOTER_HEIGHT
      );

      setFooterHeight(calculatedHeight);
      setIsReady(true);
    };
  }, [FooterImg]);
  // useEffect(() => {
  //   fetch(process.env.PUBLIC_URL + "/validationcms.json")
  //     .then((res) => {
  //       if (!res.ok) throw new Error("Failed to fetch validationcms.json");
  //       return res.json();
  //     })
  //     .then((data) => {
  //       setErrorMsgData(data);
  //     })
  //     .catch((err) => console.error("Error loading validationcms.json:", err));
  // }, []);
  // useEffect(() => {
  //   dispatch(resetTrackingData());
  // }, []);
  // useEffect(() => {
  //   console.log("--calling this line");

  //   // Get session values
  //   const savedProData = sessionStorage.getItem("selectedPro");
  //   const savedEmpData = sessionStorage.getItem("selectedemployee");
  //   const savedPB = sessionStorage.getItem("Pagebreakcheckbox");
  //   const pro = savedProData ? JSON.parse(savedProData) : [];
  //   const emp = savedEmpData ? JSON.parse(savedEmpData) : [];
  //   const self = savedPB === "true";

  //   console.log(savedProData, "--savedProData");
  //   console.log(savedEmpData, "--savedEmpData");
  //   console.log(savedPB, "--savedPB");

  //   console.log(pro, "--pro");
  //   console.log(emp, "--emp");
  //   console.log(self, "--self");

  //   setSelectedPro(pro);
  //   setSelectedEmployee(emp);
  //   setPagebreakcheckbox(self);
  // }, []);
  const handleUnlock = async () => {
    const idata = {
      action: "update",
      DailyTaskRecordID: selectedRow?.RecordID,
      ApprovedBy: EMPID,
      ApprovedStatus: "",
      DateTime: formattedDate,
      Remarks: reason,
    };

    try {
      const response = await dispatch(timeSheetPostData({ idata }));

      if (response.payload.Status === "Y") {
        toast.success(response.payload.Msg);
        dispatch(timeSheet({ data: getData }));
        //handleDialogClose();
      } else {
        toast.error(response.payload.Msg);
      }
    } catch (error) {
      console.error("Error during timesheet post:", error);
      toast.error("Something went wrong!");
    }
  };

  function AttendanceTool() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography variant="h5">Efforts - List of Tasks</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
        </Box>
      </GridToolbarContainer>
    );
  }

  //Employee
  function EmployeeTasks() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography variant="h5">Efforts - List of Personnel Tasks</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
        </Box>
      </GridToolbarContainer>
    );
  }

  //Project

  function ProjectTool() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography variant="h5">Efforts - List of Projects</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
        </Box>
      </GridToolbarContainer>
    );
  }

  const PSRTaskColumn = [
    {
      field: "RecordID",
      headerName: "RecordID",
      width: 80,
      hide: true,
    },
    // {
    //   field: "SLNO",
    //   headerName: "SL#",
    //   width: 20,
    //   hide: false,
    //   align: "right",
    // },
    // {
    //   field: "slno",
    //   headerName: "SL#",
    //   width: 50,
    //   sortable: false,
    //   filterable: false,
    //   valueGetter: (params) =>
    //     `${params.api.getRowIndexRelativeToVisibleRows(params.id) + 1}`
    // },
    {
      field: "slno",
      headerName: "SL#",
      width: 60,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      valueGetter: (params) => {
        const index = params.api.getRowIndexRelativeToVisibleRows(params.id);

        const totalVisibleRows = params.api.getAllRowIds().length;
        const totalAllRows = params.api.getRowsCount();

        if (totalVisibleRows < totalAllRows) {
          return index + 1;
        } else {
          return page * pageSize + index + 1;
        }
      },
    },
    {
      field: "Code",
      headerName: "Code",
      width: 130,
      hide: true,
    },
    {
      field: "DATE",
      headerName: "Date",
      width: 80,
    },
    {
      field: "ProjectName",
      headerName: "Project Name",
      width: 250,
      renderCell: (params) => {
        const projcode = params.row.ProjectCode || "";
        const projdesc = params.row.ProjectName || "";
        const combinedText = `${projcode} || ${projdesc}`;

        return (
          <Tooltip title={combinedText} placement="top-start" arrow>
            <div
              style={{
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {combinedText}
            </div>
          </Tooltip>
        );
      },
    },
    {
      field: "EmployeeName",
      headerName: "Personnel Name",
      width: 160,

      renderCell: (params) => {
        const EmpCode = params.row.EmployeeCode || "";
        const Empdesc = params.row.EmployeeName || "";
        const combinedText = `${EmpCode} || ${Empdesc}`;

        return (
          <Tooltip title={combinedText} placement="top-start" arrow>
            <div
              style={{
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {combinedText}
            </div>
          </Tooltip>
        );
      },
    },
    //  {
    //   field: "EmployeeCode",
    //   headerName: "Employee Code",
    //   width: 130,
    // },
    {
      field: "Description",
      headerName: "Description",
      width: 500,
      renderCell: (params) => {
        const description = params.row.Description || "";
        const comments = params.row.Comments || "";
        const combinedText = `${description} || ${comments}`;

        return (
          <Tooltip title={combinedText} placement="top-start" arrow>
            <div
              style={{
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {combinedText}
            </div>
          </Tooltip>
        );
      },
    },

    //    {
    //   field: "Description",
    //   headerName: "Description",
    //   width: 600,
    //   renderCell: (params) => {
    //     const description = params.row.Description || "";
    //     const comments = params.row.Comments || "";
    //     const combinedText = `${description} || ${comments}`;

    //     return (
    //       <div
    //         style={{
    //           width: "100%",
    //           overflow: "hidden",
    //           textOverflow: "ellipsis",
    //           whiteSpace: "nowrap",
    //         }}
    //         title={combinedText}
    //       >
    //         {combinedText}
    //       </div>
    //     );
    //   },
    // },

    {
      field: "EStimatedHourse",
      headerName: "Est Hrs",
      width: 30,
      hide: false,
      align: "right",
    },
    {
      field: "ActualHourse",
      headerName: "Act Hrs",
      width: 30,
      hide: false,
      align: "right",
    },

    {
      field: "ProjectCode",
      headerName: "ProjectCode",
      width: 130,
      hide: true,
    },

    {
      field: "EmpStatus",
      headerName: "Status",
      width: 120,
    },
  ];

  const PSRempTaskColumn = [
    {
      field: "RecordID",
      headerName: "RecordID",
      width: 80,
      hide: true,
    },
    // {
    //   field: "SLNO",
    //   headerName: "SL#",
    //   width: 20,
    //   hide: false,
    //   align: "right",
    // },
    // {
    //   field: "slno",
    //   headerName: "SL#",
    //   width: 50,
    //   sortable: false,
    //   filterable: false,
    //   valueGetter: (params) =>
    //     `${params.api.getRowIndexRelativeToVisibleRows(params.id) + 1}`,
    // },
    {
      field: "slno",
      headerName: "SL#",
      width: 60,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      valueGetter: (params) => {
        const index = params.api.getRowIndexRelativeToVisibleRows(params.id);

        const totalVisibleRows = params.api.getAllRowIds().length;
        const totalAllRows = params.api.getRowsCount();

        if (totalVisibleRows < totalAllRows) {
          return index + 1;
        } else {
          return page1 * pageSize + index + 1;
        }
      },
    },
    {
      field: "Code",
      headerName: "Code",
      width: 130,
      hide: true,
    },
    // {
    //   field: "Date",
    //   headerName: "Date",
    //   width: 130,
    // },
    {
      field: "ProjectName",
      headerName: "Project Name",
      width: 250,
      renderCell: (params) => {
        const projcode = params.row.ProjectCode || "";
        const projdesc = params.row.ProjectName || "";
        const combinedText1 = `${projcode} || ${projdesc}`;

        return (
          <Tooltip title={combinedText1} placement="top-start" arrow>
            <div
              style={{
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {combinedText1}
            </div>
          </Tooltip>
        );
      },
    },
    {
      field: "EmployeeName",
      headerName: "Personnel Name",
      width: 160,

      renderCell: (params) => {
        const EmpCode = params.row.EmployeeCode || "";
        const Empdesc = params.row.EmployeeName || "";
        const combinedText = `${EmpCode} || ${Empdesc}`;

        return (
          <Tooltip title={combinedText} placement="top-start" arrow>
            <div
              style={{
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {combinedText}
            </div>
          </Tooltip>
        );
      },
    },

    // {
    //   field: "Description",
    //   headerName: "Description",
    //   width: 500,
    //   renderCell: (params) => {
    //     const description = params.row.Description || "";
    //     const comments = params.row.Comments || "";
    //     const combinedText = `${description} || ${comments}`;

    //     return (
    //       <Tooltip title={combinedText} placement="top-start" arrow>
    //         <div
    //           style={{
    //             width: "100%",
    //             overflow: "hidden",
    //             textOverflow: "ellipsis",
    //             whiteSpace: "nowrap",
    //           }}
    //         >
    //           {combinedText}
    //         </div>
    //       </Tooltip>
    //     );
    //   },
    // },

    //    {
    //   field: "Description",
    //   headerName: "Description",
    //   width: 600,
    //   renderCell: (params) => {
    //     const description = params.row.Description || "";
    //     const comments = params.row.Comments || "";
    //     const combinedText = `${description} || ${comments}`;

    //     return (
    //       <div
    //         style={{
    //           width: "100%",
    //           overflow: "hidden",
    //           textOverflow: "ellipsis",
    //           whiteSpace: "nowrap",
    //         }}
    //         title={combinedText}
    //       >
    //         {combinedText}
    //       </div>
    //     );
    //   },
    // },

    //  {
    //   field: "ActualHours",
    //   headerName: "Act Hrs",
    //   width: 30,
    //   hide: false,
    //   align: "right",
    // },

    //  {
    //   field: "EstimatedHours",
    //   headerName: "Est Hrs",
    //   width: 30,
    //   hide: false,
    //   align: "right",
    // },
    {
      field: "TotalEstimatedHours",
      headerName: "Total Est Hrs",
      width: 80,
      hide: false,
      align: "right",
      // valueGetter: (params) => {
      //   const TotalEstHrs = params.row.TotalEstimatedHours || "";
      //   const totalEstHrs = TotalEstHrs;
      //   return totalEstHrs;
      // }
    },
    {
      field: "TotalActualHours",
      headerName: "Total Act Hrs",
      width: 80,
      hide: false,
      align: "right",
      // valueGetter: (params) => {
      //   const TotalActHrs = params.row.TotalActualHours || "";
      //   const totalActHrs = TotalActHrs;
      //   return totalActHrs;
      // }
    },

    {
      field: "ProjectCode",
      headerName: "ProjectCode",
      width: 130,
      hide: true,
    },

    // {
    //   field: "EmpStatus",
    //   headerName: "Status",
    //   width: 120,
    // },
  ];

  const PSRprojectColumn = [
    {
      field: "RecordID",
      headerName: "RecordID",
      width: 80,
      hide: true,
    },
    // {
    //   field: "SLNO",
    //   headerName: "SL#",
    //   width: 20,
    //   hide: false,
    //   align: "right",
    // },
    // {
    //   field: "slno",
    //   headerName: "SL#",
    //   width: 50,
    //   sortable: false,
    //   filterable: false,
    //   valueGetter: (params) =>
    //     `${params.api.getRowIndexRelativeToVisibleRows(params.id) + 1}`,
    // },
    {
      field: "slno",
      headerName: "SL#",
      width: 60,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      valueGetter: (params) => {
        const index = params.api.getRowIndexRelativeToVisibleRows(params.id);

        const totalVisibleRows = params.api.getAllRowIds().length;
        const totalAllRows = params.api.getRowsCount();

        if (totalVisibleRows < totalAllRows) {
          return index + 1;
        } else {
          return page2 * pageSize + index + 1;
        }
      },
    },
    {
      field: "Code",
      headerName: "Code",
      width: 130,
      hide: true,
    },
    // {
    //   field: "Date",
    //   headerName: "Date",
    //   width: 130,
    // },
    {
      field: "ProjectName",
      headerName: "Project Name",
      width: 250,
      renderCell: (params) => {
        const projcode = params.row.ProjectCode || "";
        const projdesc = params.row.ProjectName || "";
        const combinedText = `${projcode} || ${projdesc}`;

        return (
          <Tooltip title={combinedText} placement="top-start" arrow>
            <div
              style={{
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {combinedText}
            </div>
          </Tooltip>
        );
      },
    },
    // {
    //   field: "EmployeeName",
    //   headerName: "Employee Name",
    //   width: 130,
    // },
    // {
    //   field: "Description",
    //   headerName: "Description",
    //   width: 600,
    //   renderCell: (params) => {
    //     const description = params.row.Description || "";
    //     const comments = params.row.Comments || "";
    //     const combinedText = `${description} || ${comments}`;

    //     return (
    //       <Tooltip title={combinedText} placement="top-start" arrow>
    //         <div
    //           style={{
    //             width: "100%",
    //             overflow: "hidden",
    //             textOverflow: "ellipsis",
    //             whiteSpace: "nowrap",
    //           }}
    //         >
    //           {combinedText}
    //         </div>
    //       </Tooltip>
    //     );
    //   },
    // },

    //    {
    //   field: "Description",
    //   headerName: "Description",
    //   width: 600,
    //   renderCell: (params) => {
    //     const description = params.row.Description || "";
    //     const comments = params.row.Comments || "";
    //     const combinedText = `${description} || ${comments}`;

    //     return (
    //       <div
    //         style={{
    //           width: "100%",
    //           overflow: "hidden",
    //           textOverflow: "ellipsis",
    //           whiteSpace: "nowrap",
    //         }}
    //         title={combinedText}
    //       >
    //         {combinedText}
    //       </div>
    //     );
    //   },
    // },
    {
      field: "TotalEstimatedHours",
      headerName: "Total Est Hrs",
      width: 80,
      hide: false,
      align: "right",
      // valueGetter: (params) => {
      //   const TotalEstHrs = params.row.TotalEstimatedHours || "";
      //   const totalEstHrs = TotalEstHrs;
      //   return totalEstHrs;
      // }
    },
    {
      field: "TotalActualHours",
      headerName: "Total Act Hrs",
      width: 80,
      hide: false,
      align: "right",
      // valueGetter: (params) => {
      //   const TotalActHrs = params.row.TotalActualHours || "";
      //   const totalActHrs = TotalActHrs;
      //   return totalActHrs;
      // }
    },

    {
      field: "ProjectCode",
      headerName: "ProjectCode",
      width: 130,
      hide: true,
    },

    // {
    //   field: "EmpStatus",
    //   headerName: "Status",
    //   width: 120,
    // },
  ];

  //Efforts - List of Tasks
  const safeAttendanceData = Array.isArray(PSRData) ? PSRData : [];
  console.log(safeAttendanceData, "safeAttendanceData");
  //List of Employee Tasks
  const EmployeeTasksData = Array.isArray(PSRempTaskData) ? PSRempTaskData : [];
  console.log(EmployeeTasksData, "EmployeeTasksData");
  //Efforts - List of Projects
  const LisOfProjectData = Array.isArray(PSRprojectTaskData)
    ? PSRprojectTaskData
    : [];
  console.log(LisOfProjectData, "LisOfProjectData");

  // Then:
  const ApprovedData = safeAttendanceData.filter(
    (row) => row.ApprovedStatus === "A" || "C",
  );
  console.log(ApprovedData, "===ApprovedData");
  /***********Attendance ************/

  // const currentMonthNumber = new Date().getMonth() + 1;
  const currentYear = new Date().getFullYear();
  const currentDate = new Date().toISOString().split("T")[0];

  const AttInitialvalues = {
    // checkbox1: true,
    // checkbox5: true,
    // checkbox2: false,
    // checkbox3: false,
    // checkbox4: false,
    // checkbox6: false,
    // checkbox7: false,
    // fromDate: PSRData.fromDate,
    // toDate: PSRData.toDate
    fromDate: currentDate,
    toDate: currentDate,
    Status: ""
    // fromDate: sessionStorage.getItem("fromDate") || currentDate,
    // toDate: sessionStorage.getItem("toDate") || currentDate,
    // Status: sessionStorage.getItem("Status") || "",
  };
  const [getData, setData] = useState("");
  const [useCurrentEmp, setUseCurrentEmp] = useState(true);
  const [Pagebreakcheckbox, setPagebreakcheckbox] = useState(false);
  console.log(Pagebreakcheckbox, "--Pagebreakcheckbox");

  //FOR HIDE AND SHOW OF CHARTS AND GRID
  const [hasApplied, setHasApplied] = useState(false);

  //PIE CHART
  const statusReportData = useSelector(
    (state) => state.formApi.ProjectStatusReportData,
  );
  const pieLoading = useSelector(
    (state) => state.formApi.ProjectStatusReportLoading,
  );

  //PRODUCT COSTING
  const costingApiData = useSelector(
    (state) => state.formApi.ProductCostingData,
  );
  const ProductCostingLoading = useSelector(
    (state) => state.formApi.ProductCostingLoading,
  );

  //COSTING OVERVIEW
  const CostOverviewData = useSelector(
    (state) => state.formApi.CostOverviewData,
  );
  console.log("🚀 ~ EditProjectStatusReport ~ CostOverviewData:", CostOverviewData)
  const CostOverviewLoading = useSelector(
    (state) => state.formApi.CostOverviewLoading,
  );

  //COSTING TREND
  const CostTrendData = useSelector(
    (state) => state.formApi.CostTrendData,
  );
  console.log("🚀 ~ EditProjectStatusReport ~ CostOverviewData:", CostOverviewData)
  const CostTrendLoading = useSelector(
    (state) => state.formApi.CostTrendLoading,
  );

  //Employee Overrun
  const EmployeeOverrunData = useSelector(
    (state) => state.formApi.EmployeeOverrunData,
  );
  console.log("🚀 ~ EditProjectStatusReport ~ EmployeeOverrunData:", EmployeeOverrunData)
  const EmployeeOverrunLoading = useSelector(
    (state) => state.formApi.EmployeeOverrunLoading,
  );

  const employees = statusReportData?.Employees || [];

  const totals = employees.reduce(
    (acc, emp) => {
      acc.Completed += Number(emp.PTCompleted || 0);
      acc.BackLog += Number(emp.PTBackLog || 0);
      acc.InProgress += Number(emp.PTInprogress || 0);
      acc.Approved += Number(emp.PTApproved || 0);
      acc.Transfered += Number(emp.Transfered || 0);
      acc.TotalTasks += Number(emp.PTTasks || 0);
      return acc;
    },
    {
      Completed: 0,
      BackLog: 0,
      InProgress: 0,
      Approved: 0,
      Transfered: 0,
      TotalTasks: 0,
    },
  );

  const getPercent = (value) => {
    if (!totals.TotalTasks) return 0;
    return Math.round((value / totals.TotalTasks) * 100);
  };

  const SummaryCard = ({ title, value, percent, color, loading }) => {
    return (
      <Paper
        elevation={2}
        sx={{
          p: 2,
          borderRadius: 3,
          display: "flex",
          flexDirection: "column",
          gap: 1,
          borderLeft: `5px solid ${color}`,
        }}
      >
        {/* {loading ? <CircularProgress /> : null} */}
        <Typography variant="h5" color="text.secondary" fontWeight="bold">
          {title.toUpperCase()}
        </Typography>

        <Typography variant="h4" fontWeight="bold" color={`${color}`}>
          {value.toLocaleString()}
        </Typography>

        <Typography variant="h6" color="text.secondary">
          {percent}% of Total Tasks
        </Typography>
      </Paper>
    );
  };
  const costingSummary = costingApiData?.CostingSummary || [];
  console.log("🚀 ~ EditProjectStatusReport ~ costingSummary:", costingSummary)

  const CostingSummaryCard = ({ title, value, percent, color, subHeading, loading }) => {
    return (
      <Paper
        elevation={2}
        sx={{
          p: 2,
          borderRadius: 3,
          display: "flex",
          flexDirection: "column",
          gap: 1,
          borderLeft: `5px solid ${color}`,
        }}
      >
        {/* {loading ? <CircularProgress /> : null} */}

        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="h5" color="text.secondary" fontWeight="bold">
            {title.toUpperCase()}
          </Typography>
          <Typography variant="h6" color="text.secondary">
            {percent}%
          </Typography>
        </Box>
        <Typography variant="h4" fontWeight="bold" color={`${color}`}>
          ₹{value.toLocaleString()}
        </Typography>
        <Typography variant="h6" color="text.secondary">
          {subHeading}
        </Typography>
        {/* Progress Bar */}
        <LinearProgress
          variant="determinate"
          value={percent}
          sx={{
            mt: 1,
            height: 5,
            borderRadius: 5,
            backgroundColor: "#e0e0e0",
            "& .MuiLinearProgress-bar": {
              backgroundColor: color,
            },
          }}
        />

      </Paper>
    );
  };
  // const productCostingData = [
  //   { name: "Agile Task", estimated: 3800, actual: 4200 },
  //   { name: "LGEMS", estimated: 1200, actual: 900 },
  //   { name: "BDS Supernus", estimated: 800, actual: 600 },
  //   { name: "BDS Sangamo", estimated: 600, actual: 500 },
  //   { name: "AI Project", estimated: 200, actual: 150 },
  // ];
  const productCostingData =
    costingApiData?.Data?.map((item) => ({
      name: item.ProjectName,
      estimated: Number(item.EstimatedHours || 0),
      actual: Number(item.ActualHours || 0),
    })) || [];

  const hasProductCostingData = productCostingData.length > 0;
  const costingBarData = {
    labels: productCostingData.map((p) => p.name),
    datasets: [
      {
        label: "Estimated hrs",
        data: productCostingData.map((p) => p.estimated),
        backgroundColor: "#4e79a7", // blue
        borderRadius: 6,
        barThickness: 12,
      },
      {
        label: "Actual hrs",
        data: productCostingData.map((p) => p.actual),
        backgroundColor: "#59a14f", // green
        borderRadius: 6,
        barThickness: 12,
      },
    ],
  };

  const costingBarOptions = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: "y",

    plugins: {
      legend: {
        position: "top",
        align: "start",
        labels: {
          boxWidth: 10,
          boxHeight: 10,
          usePointStyle: true,
          pointStyle: "circle",
        },
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: function (context) {
            return `${context.dataset.label}: ${context.raw} hrs`;
          },
        },
      },
    },

    scales: {
      x: {
        grid: {
          color: "#eee",
        },
        ticks: {
          callback: (value) => value.toLocaleString(),
        },
      },
      y: {
        grid: {
          display: false,
        },
      },
    },
  };

  const costOverview =
    CostOverviewData?.Data?.map((item) => ({
      name: item.ProjectName,
      ActualCost: item.ActualCost,
      ScheduledCost: item.ScheduledCost,
      Budget: item.Budget,
      OtherExpenses: item.OtherExpenses,
    })) || [];

  const hasCostOverviewData = costOverview.length > 0;

  const costOverviewData = {
    // labels: ["Agile Task Mgmt"],
    labels: costOverview.map((o) => o.name),

    datasets: [
      {
        label: "Budget",
        data: costOverview.map((o) => o.Budget),
        backgroundColor: "#7e6bb3",
        borderRadius: 6,
      },
      {
        label: "Scheduled",
        data: costOverview.map((o) => o.ScheduledCost),
        backgroundColor: "#4e79a7",
        borderRadius: 6,
      },
      {
        label: "Actual",
        data: costOverview.map((o) => o.ActualCost),
        backgroundColor: "#59a14f",
        borderRadius: 6,
      },
      {
        label: "Other expenses",
        data: costOverview.map((o) => o.OtherExpenses),
        backgroundColor: "#f28e2b",
        borderRadius: 6,
      },
    ],
  };

  const costOverviewOptions = {
    responsive: true,
    maintainAspectRatio: false,

    plugins: {
      legend: {
        position: "top",
        align: "start",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
        },
      },
    },

    scales: {
      x: {
        grid: { display: false },
      },
      y: {
        grid: { color: "#eee" },
        ticks: {
          callback: (value) => `₹${(value / 100000).toFixed(1)}L`,
        },
      },
    },
  };

  const months = CostTrendData?.Months || [];
  const projects = CostTrendData?.Projects || [];
  const lastMonth = CostTrendData?.Projects?.[0]?.KPI?.LastMonth;
  const yAxis = CostTrendData?.YAxis || {};
  const varianceSummary = CostTrendData?.AggregateVariance || [];
  // const costTrend =
  //   rawTrendData?.map((item) => ({
  //     Months: item.Months,
  //     MonthlyScheduledHours: item.Monthly?.ScheduledHours,
  //   })) || [];


  const datasets = projects.flatMap((proj) => [
    {
      label: proj.DatasetLabels?.Scheduled || `${proj.ProjectCode} (Scheduled)`,
      data: proj.CumulativeCost?.Scheduled || [],
      borderColor: proj.Colors?.Scheduled || "#4e79a7",
      color: proj.Colors?.Scheduled || "#4e79a7",
      backgroundColor: "transparent",
      // borderDash: [6, 6], 

      borderWidth: 2,
      tension: 0.3,
      pointRadius: 3,
      pointHoverRadius: 4,
      fill: false,
    },
    {
      label: proj.DatasetLabels?.Actual || `${proj.ProjectCode} (Actual)`,
      data: proj.CumulativeCost?.Actual || [],
      borderColor: proj.Colors?.Actual || "#59a14f",
      color: proj.Colors?.Actual || "#59a14f",
      backgroundColor: "transparent",

      borderWidth: 2,
      tension: 0.3,
      pointRadius: 3,
      pointHoverRadius: 4,
      fill: false,
    },
  ]);

  const hasCostTrendData =
    months.length > 0 &&
    projects.some(
      (p) =>
        p.CumulativeCost?.Scheduled?.some((v) => v > 0) ||
        p.CumulativeCost?.Actual?.some((v) => v > 0)
    );
  // const costTrendData = {
  //   labels: months,
  //   datasets: [
  //     {
  //       label: "Scheduled",
  //       data: scheduled,
  //       borderColor: "#4e79a7",
  //       backgroundColor: "rgba(78,121,167,0.15)",
  //       fill: true,
  //       tension: 0.4,
  //       pointRadius: 4,
  //     },
  //     {
  //       label: "Actual",
  //       data: actual,
  //       borderColor: "#59a14f",
  //       backgroundColor: "rgba(89,161,79,0.15)",
  //       fill: true,
  //       tension: 0.4,
  //       pointRadius: 4,
  //     },
  //   ],
  // };
  const costTrendData = {
    labels: months,
    datasets,
  };
  const costTrendOptions = {
    responsive: true,
    maintainAspectRatio: false,

    plugins: {
      legend: {
        position: "top",
        align: "start",
        labels: {
          usePointStyle: true,
          pointStyle: "rect", // 👈 square like reference
          boxWidth: 8,
          boxHeight: 8,
          padding: 12,
          font: {
            size: 11,
            weight: 500,
          },
          color: "#444",
        },
      },
    },

    scales: {
      x: {
        grid: { display: false },
      },
      y: {
        min: yAxis?.Min ?? 0,
        max: yAxis?.Max,

        grid: {
          color: "#eee",
        },

        ticks: {
          stepSize: yAxis?.TickInterval,

          callback: function (value) {
            const index = yAxis?.Ticks?.indexOf(value);
            return index !== -1
              ? yAxis?.TickLabels?.[index]
              : `₹${(value / 100000).toFixed(0)}L`;
          },
        },
      },
    },
  };

  const chart = EmployeeOverrunData?.Chart;

  const overrunBarData = {
    labels: chart?.Labels || [],
    datasets: [
      {
        label: "Estimated hrs",
        data: chart?.EstimatedHours || [],
        backgroundColor: "#5B8FF9",
        borderRadius: 5,
        barThickness: 18,
      },
      {
        label: "Overrun hrs",
        data: chart?.OverrunHours || [],
        backgroundColor: "#F4664A",
        borderRadius: 5,
        barThickness: 18,
      },
    ],
  };

  const hasEmployeeOverrunData =
    chart?.Labels && chart.Labels.length > 0;

  const overrunBarOptions = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: "y", // 👈 horizontal
    plugins: {
      legend: {
        position: "top",
      },
    },
    scales: {
      x: {
        stacked: false, // 👈 IMPORTANT
        grid: { display: false },
      },
      y: {
        stacked: false,
        grid: { display: false },
      },
    },
  };
  //BAR CHART
  const statusReportDataBar = useSelector(
    (state) => state.formApi.PSRBarChartData,
  );

  const barLoading = useSelector(
    (state) => state.formApi.PSRBarChartLoading, // if you have separate reducer
  );
  const ProjectsBar = statusReportDataBar?.Projects || [];

  const totalsBar = ProjectsBar.reduce(
    (acc, emp) => {
      acc.Completed += Number(emp.Completed || 0);
      acc.BackLog += Number(emp.BackLog || 0);
      acc.InProgress += Number(emp.Inprogress || 0);
      acc.Approved += Number(emp.Approved || 0);
      acc.Transfered += Number(emp.Transfered || 0);
      acc.OverallTasks += Number(emp.OverallTasks || 0);

      return acc;
    },
    {
      Completed: 0,
      BackLog: 0,
      InProgress: 0,
      Approved: 0,
      Transfered: 0,
      OverallTasks: 0,
    },
  );

  const attendaceFnSave = async (values) => {
    const statusMapping = {
      // checkbox1: "S", // TaskSource
      // checkbox2: "M", // TaskSource
      // checkbox3: "SH", // TaskSource
      // checkbox5: "AP", // Status
      // checkbox6: "RJ", // Status
      // checkbox7: "PB",
    };

    let taskSourceValues = [];
    let statusValues = [];
    const statusCodeMap = {
      Inprogress: "'I'",
      Completed: "'C'",
      Approved: "'AP'",
      Rejected: "'RJ'",
      Created: "'CR'",
      Assigned: "'AS'",
      Notyetstarted: "'N'",
    };
    const statusCodeMapChart = {
      Inprogress: "I",
      Completed: "C",
      Approved: "AP",
      Rejected: "RJ",
      Created: "CR",
      Assigned: "AS",
      Notyetstarted: "N",
    };

    let AttendanceFilter = "";
    let ProjectFilter = "";

    const hasProject = selectedPro.length > 0;
    const hasEmployee = selectedemployee.length > 0 || useCurrentEmp;
    const hasFromDateToDate = values.fromDate && values.toDate;
    const hasStatus = values.Status && values.Status.length > 0;

    // Construct reusable IDs
    // const employeeID = useCurrentEmp
    //   ? EMPID
    //   : [EMPID, ...selectedemployee.map((emp) => emp.RecordID)].join(",");


    //CHANGED AS ON 06/04/2026 -- MANAGERID BEING SENT ALONG WITH SELECTED EMPID
    const employeeID =
      selectedemployee.length > 0
        ? selectedemployee.map((emp) => emp.RecordID).join(",")
        : EMPID;

    //  selectedemployee.map((emp) => emp.RecordID).join(",");

    const projectID = selectedPro.map((proj) => proj.RecordID).join(",");
    const selectedStatusArr = values.Status.split(",");
    const statusCodes = selectedStatusArr
      .map((s) => statusCodeMap[s])
      .join(",");
    const statusCodesPieChart = selectedStatusArr
      .map((s) => statusCodeMapChart[s])
      .join(",");
    // case 9: Project + Employee/self + FromDate & ToDate
    if (hasProject && hasEmployee && hasFromDateToDate && hasStatus) {
      AttendanceFilter = `DT_EMPRECID IN(${employeeID}) AND DT_PRECID IN(${projectID}) AND DT_DATE BETWEEN '${values.fromDate}' AND '${values.toDate}' AND E2.EMP_CMRECID=${CompanyID} AND DT_STATUS IN (${statusCodes})`;
      ProjectFilter = `DT_EMPRECID IN(${employeeID}) AND DT_PRECID IN(${projectID}) AND P_CMRECID IN(${CompanyID})`;
    }

    // case 8: Project + Employee/self
    else if (hasProject && hasEmployee) {
      console.log("--hasProject", hasProject);
      console.log("--hasEmployee", hasEmployee);

      AttendanceFilter = `DT_EMPRECID IN(${employeeID}) AND DT_PRECID IN(${projectID})AND DT_DATE BETWEEN '${values.fromDate}' AND '${values.toDate}' AND E2.EMP_CMRECID=${CompanyID}`;
      ProjectFilter = `DT_EMPRECID IN(${employeeID}) AND DT_PRECID IN(${projectID}) AND P_CMRECID IN(${CompanyID})`;
    } else if (hasProject && hasEmployee && hasStatus) {
      console.log("--hasProject", hasProject);
      console.log("--hasEmployee", hasEmployee);

      AttendanceFilter = `DT_EMPRECID IN(${employeeID}) AND DT_PRECID IN(${projectID}) AND E2.EMP_CMRECID=${CompanyID} AND DT_STATUS IN(${statusCodes}) AND DT_DATE BETWEEN '${values.fromDate}' AND '${values.toDate}'`;
      ProjectFilter = `DT_EMPRECID IN(${employeeID}) AND DT_PRECID IN(${projectID}) AND P_CMRECID IN(${CompanyID})`;
    }

    // case 7: Project + FromDate & ToDate
    else if (hasProject && hasFromDateToDate) {
      AttendanceFilter = `ProjectID IN(${projectID}) AND DT_DATE BETWEEN '${values.fromDate}' AND '${values.toDate}' AND E2.EMP_CMRECID=${CompanyID}`;
    }

    // case 6: Employee/self + FromDate & ToDate
    else if (hasEmployee && hasFromDateToDate) {
      AttendanceFilter = `DT_EMPRECID IN(${employeeID}) AND DT_DATE BETWEEN '${values.fromDate}' AND '${values.toDate}' AND E2.EMP_CMRECID=${CompanyID}`;
    }

    // case 5: only FromDate & ToDate
    else if (hasFromDateToDate) {
      AttendanceFilter = `DT_DATE BETWEEN '${values.fromDate}' AND '${values.toDate}' AND E2.EMP_CMRECID=${CompanyID}`;
    }

    // case 4: only self (no selectedemployee, just useCurrentEmp)
    else if (useCurrentEmp && !selectedemployee.length) {
      AttendanceFilter = `DT_EMPRECID IN(${EMPID}) AND DT_DATE BETWEEN '${values.fromDate}' AND '${values.toDate}'`;
      ProjectFilter = `DT_EMPRECID IN(${EMPID}) AND P_CMRECID IN(${CompanyID})`;
    }

    // case 3: only Employee/self
    else if (hasEmployee) {
      AttendanceFilter = `DT_EMPRECID IN(${employeeID}) AND E2.EMP_CMRECID=${CompanyID} AND DT_DATE BETWEEN '${values.fromDate}' AND '${values.toDate}'`;
      ProjectFilter = `DT_EMPRECID IN(${employeeID}) AND P_CMRECID IN(${CompanyID})`;
    }

    // case 2: only Project
    else if (hasProject) {
      AttendanceFilter = `DT_PRECID IN(${projectID}) AND E2.EMP_CMRECID=${CompanyID} AND DT_DATE BETWEEN '${values.fromDate}' AND '${values.toDate}'`;
      ProjectFilter = `DT_PRECID IN(${projectID}) AND P_CMRECID IN(${CompanyID})`;
    }

    // case 1: Nothing selected (empty filter)
    else {
      AttendanceFilter = ""; // no filters applied
      ProjectFilter = "";
    }

    const data = { AttendanceFilter, ProjectFilter };
    setData(data);
    dispatch(PSRreportpost({ data }));

    //PIE CHART
    const projectStatusPayload = {
      EmployeeIDs: employeeID, // "123,126"
      CompanyID: CompanyID, // "76"
      Status: statusCodesPieChart, // "AP,RJ,AS"
      ProjectIDS: projectID,
      FromDate: values.fromDate,
      Todate: values.toDate
    };

    // 3️⃣ Call ProjectStatusReport
    await dispatch(ProjectStatusReport({ data: projectStatusPayload }));
    await dispatch(ProjectStatusReportBarChart({ data: projectStatusPayload }));
    await dispatch(ProductCosting({ data: projectStatusPayload }));
    await dispatch(CostOverview({ data: projectStatusPayload }));
    await dispatch(CostTrend({ data: projectStatusPayload }));
    await dispatch(EmployeeOverrun({ data: projectStatusPayload }));

    //FOR HIDE AND SHOW OF CHARTS AND GRID
    setHasApplied(true);
  };
  // console.log(values.fromDate, "values.fromDate");
  // console.log(values.toDate, "values.fromDate");

  console.log(getData, "---------------------GETDATA");

  const explorelistViewData = useSelector(
    (state) => state.exploreApi.explorerowData,
  );
  const explorelistViewColumn = useSelector(
    (state) => state.exploreApi.explorecolumnData,
  );
  const exploreLoading = useSelector((state) => state.exploreApi.loading);
  const screenChange = (event) => {
    setScreen(event.target.value);
  };
  const VISIBLE_FIELDS = [
    "SLNO",
    "OtDate",
    "NumberOfHours",
    "Status",
    "action",
  ];
  const [funMode, setFunMode] = useState("A");
  const columns = React.useMemo(
    () =>
      explorelistViewColumn
        ? explorelistViewColumn.filter((column) =>
          VISIBLE_FIELDS.includes(column.field),
        )
        : [],
    [explorelistViewColumn],
  );

  const fnLogOut = (props) => {
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") navigate("/");
        if (props === "Close") navigate(-1);
      }
    });
  };
  const [empData, setempData] = useState(null);
  // const handleSelectionEmployeeChange = (newValue) => {
  //   if (newValue) {
  //     setempData(newValue);
  //     console.log(newValue.RecordID, "--selectedproductid");
  //   } else {
  //     setempData(null);
  //   }
  //   setUseCurrentEmp(false);
  // };
  const [open, setOpen] = React.useState(false);

  const [reason, setReason] = useState("");
  const [selectedPro, setSelectedPro] = useState([]);
  const [selectedemployee, setSelectedEmployee] = useState([]);

  // const projecID = selectedPro.map((ProName) => ProName.RecordID).join(",");
  const employeeID = selectedemployee
    .map((Employee) => Employee.RecordID)
    .join(",");
  console.log(employeeID, "--employeeID");

  const pieData =
    employees.length === 0
      ? {
        labels: [],
        datasets: [{ data: [] }],
      }
      : {
        labels: [
          "Completed",
          "Back Log",
          "In Progress",
          "Approved",
          "Transfered",
        ],
        datasets: [
          {
            data: [
              totals.Completed,
              totals.BackLog,
              totals.InProgress,
              totals.Approved,
              totals.Transfered,
            ],
            backgroundColor: [
              "#4caf50",
              "#f44336",
              "#2196f3",
              "#9c27b0",
              "#ff9800",
            ],
          },
        ],
      };

  // const barData = {
  //   labels: [
  //     "Completed",
  //     "BackLog",
  //     "In Progress",
  //     "Approved",
  //     "Transfered",
  //     "OverallTasks",
  //   ],
  //   datasets: [
  //     {
  //       label: "Tasks",
  //       data: [
  //         totalsBar.Completed,
  //         totalsBar.BackLog,
  //         totalsBar.InProgress,
  //         totalsBar.Approved,
  //         totalsBar.Transfered,
  //         totalsBar.OverallTasks,
  //       ],
  //       backgroundColor: [
  //         "#4caf50",
  //         "#e3564c",
  //         "#2196f3",
  //         "#9c27b0",
  //         "#ff9800",
  //         "#00a2ff",
  //       ],
  //     },
  //   ],
  // };

  // const barData = {
  //   labels: ["Tasks"], // single group

  //   datasets: [
  //     {
  //       label: "Completed",
  //       data: [totalsBar.Completed],
  //       backgroundColor: "#4caf50",
  //     },
  //     {
  //       label: "Back Log",
  //       data: [totalsBar.BackLog],
  //       backgroundColor: "#e3564c",
  //     },
  //     {
  //       label: "In Progress",
  //       data: [totalsBar.InProgress],
  //       backgroundColor: "#2196f3",
  //     },
  //     {
  //       label: "Approved",
  //       data: [totalsBar.Approved],
  //       backgroundColor: "#9c27b0",
  //     },
  //     {
  //       label: "Transfered",
  //       data: [totalsBar.Transfered],
  //       backgroundColor: "#ff9800",
  //     },
  //     {
  //       label: "Overall Tasks",
  //       data: [totalsBar.OverallTasks],
  //       backgroundColor: "#0015ff",
  //     },
  //   ],
  // };
  const barData = {
    labels: ProjectsBar.map(p => p.ProjectName),

    datasets: [

      {
        label: "Completed",
        data: ProjectsBar.map(p => Number(p.Completed || 0)),
        backgroundColor: "#4caf50",
        barThickness: 20,
      },
      {
        label: "Back Log",
        data: ProjectsBar.map(p => Number(p.BackLog || 0)),
        backgroundColor: "#e3564c",
        barThickness: 20,
      },
      {
        label: "In Progress",
        data: ProjectsBar.map(p => Number(p.Inprogress || 0)),
        backgroundColor: "#2196f3",
        barThickness: 20,
      },
      {
        label: "Approved",
        data: ProjectsBar.map(p => Number(p.Approved || 0)),
        backgroundColor: "#9c27b0",
        barThickness: 20,
      },
      {
        label: "Transfered",
        data: ProjectsBar.map(p => Number(p.Transfered || 0)),
        backgroundColor: "#ff9800",
        barThickness: 20,
      },
    ],
  };

  return (
    <React.Fragment>
      {/* {getLoading && <LinearProgress />} */}
      <Paper
        elevation={3}
        sx={{ margin: "0px 10px", background: "#F2F0F0", height: "40px" }}
      >
        <Box display="flex" justifyContent="space-between">
          <Box display="flex" borderRadius="3px" alignItems="center">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            {/* <Typography
              variant="h4"
              sx={{ fontsize: "19px", marginLeft: "10px" }}
            >
              Project Report (
              {useCurrentEmp
                ? EMPNAME
                : selectedemployee.length > 0
                  ? selectedemployee.map((emp) => emp.Name).join(", ")
                  : ""}
              )
            </Typography> */}
            <Typography
              variant="h4"
              sx={{ fontSize: "19px", marginLeft: "10px", color:"#0000D1" }}
            >
              Project Report (
              {useCurrentEmp
                ? EMPNAME
                : selectedemployee.length > 0
                  ? (() => {
                    const maxShow = 2;
                    const names = selectedemployee.map((emp) => emp.Name);

                    if (names.length <= maxShow) {
                      return names.join(", ");
                    }

                    return `${names.slice(0, maxShow).join(", ")} +${names.length - maxShow
                      } more`;
                  })()
                  : ""}
              )
            </Typography>
          </Box>

          <Box display="flex">
            {/* <Tooltip title="Attendance ">
            <IconButton
              onClick={() => navigate("/Apps/TR217/Attendance")}
              color="primary"
            >
              <ListAltOutlinedIcon />
            </IconButton>
          </Tooltip> */}
            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>
      {/* {(pieLoading || barLoading || PSRLoading) ? (
        <CircularProgress />
      ) : false} */}
      <Backdrop
        sx={{
          color: "#1976d2",
          zIndex: (theme) => theme.zIndex.drawer + 999,
          backgroundColor: "transparent"   // remove dim effect
        }}
        open={pieLoading || barLoading || PSRLoading || ProductCostingLoading || CostOverviewLoading || CostTrendLoading}
      >
        <CircularProgress />
      </Backdrop>
      <Paper elevation={3} sx={{ margin: "10px" }}>

        {/* <Box m="10px"> */}
        <Formik
          initialValues={AttInitialvalues}
          enableReinitialize={true}
          onSubmit={(values, { resetForm }) => {
            setTimeout(() => {
              attendaceFnSave(values, resetForm);
            }, 100);
          }}
        >
          {({
            errors,
            touched,
            handleBlur,
            handleChange,
            isSubmitting,
            values,
            handleSubmit,
            resetForm,
            setFieldValue,
          }) => (
            <form
              onSubmit={handleSubmit}
              // onReset={() => {
              //   setFieldValue("Employee", []);
              //   setFieldValue("block", []);
              //   resetForm();
              //   dispatch(resetTrackingData());
              //   setSelectedPro([]);
              //   setSelectedEmployee([]);
              //   setPagebreakcheckbox(false);
              //   sessionStorage.removeItem("selectedPro");
              //   sessionStorage.removeItem("selectedemployee");
              //   sessionStorage.removeItem("Pagebreakcheckbox");
              //   sessionStorage.removeItem("fromDate");
              //   sessionStorage.removeItem("toDate");
              //   dispatch(resetProjectStatusReport());
              //   dispatch(resetPSRBarChart());
              //   setHasApplied(false);
              // }}
              onReset={() => {
                setFieldValue("Employee", []);
                setFieldValue("block", []);
                setFieldValue("Status", "");
                resetForm();
                dispatch(resetTrackingData());
                setSelectedPro([]);
                setSelectedEmployee([]);
                setPagebreakcheckbox(false);

                sessionStorage.removeItem("selectedPro");
                sessionStorage.removeItem("selectedemployee");
                sessionStorage.removeItem("Pagebreakcheckbox");
                sessionStorage.removeItem("fromDate");
                sessionStorage.removeItem("toDate");

                dispatch(resetProjectStatusReport());
                dispatch(resetPSRBarChart());

                setHasApplied(false);
              }}
            >
              <Box
                display="flex"
                alignItems="center"
                flexWrap="wrap"
                gap={2}
                sx={{ p: 2 }}
              >
                {/* Project Dropdown */}
                <Box sx={{ minWidth: 200 }}>
                  <MultiFormikOptimizedAutocomplete
                    sx={{ width: "100%" }}
                    name="ProName"
                    label="Project"
                    id="ProName"
                    // value={selectedPro}
                    value={Array.isArray(selectedPro) ? selectedPro : []}
                    onChange={(e, newValue) => {
                      setFieldValue("block", newValue);
                      setSelectedPro(newValue);
                      if (newValue)
                        sessionStorage.setItem(
                          "selectedPro",
                          JSON.stringify(newValue),
                        );
                      else sessionStorage.removeItem("selectedPro");
                      const projecIDfilter = newValue
                        .map((ProName) => ProName.RecordID)
                        .join(",");
                      const fullURL = `${listViewurl}?data=${encodeURIComponent(
                        JSON.stringify({
                          Query: {
                            AccessID: "2115",
                            ScreenName: "EMPLOYEETEAMS",
                            Filter: `ProjectID IN(${projecIDfilter}) AND CompanyID='${companyID}' GROUP BY RecordID`,
                            Any: "",
                            CompId: companyID,
                          },
                        }),
                      )}`;

                      setEmployeeURL(fullURL);
                    }}
                    url={`${listViewurl}?data=${encodeURIComponent(
                      JSON.stringify({
                        Query: {
                          AccessID: "2114",
                          ScreenName: "Project",
                          Filter: `parentID=${companyID} AND EmployeeID=${EMPID}`,
                          Any: "",
                        },
                      }),
                    )}`}
                  />
                </Box>

                {/* Employee Dropdown */}
                {isManager == "1" && (
                  <Box sx={{ minWidth: 180 }}>
                    <MultiFormikOptimizedselectAutocomplete
                      sx={{ width: "100%" }}
                      name="Employee"
                      label="Personnel"
                      id="Employee"
                      value={selectedemployee}
                      onChange={(e, newValue) => {
                        setFieldValue("Employee", newValue);
                        setSelectedEmployee(newValue);
                        if (newValue)
                          sessionStorage.setItem(
                            "selectedemployee",
                            JSON.stringify(newValue),
                          );
                        else sessionStorage.removeItem("selectedemployee");
                        if (
                          newValue.length > 0 &&
                          !(
                            newValue.length === 1 &&
                            newValue[0].RecordID === EMPID
                          )
                        ) {
                          setUseCurrentEmp(false);
                        }
                      }}
                      url={employeeURL}
                    />
                  </Box>
                )}

                <FormControl
                  variant="standard"
                  sx={{ marginTop: "0px", minWidth: 160 }}
                  focused
                >
                  <InputLabel id="Status-label">Status</InputLabel>

                  <Select
                    labelId="Status-label"
                    id="Status"
                    name="Status"
                    multiple
                    value={values.Status ? values.Status.split(",") : []}
                    onChange={(e) => {
                      handleChange({
                        target: {
                          name: "Status",
                          value: e.target.value.join(","),
                        },
                      });
                    }}
                    renderValue={(selected) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.4 }}>
                        {selected.map((value) => (
                          <Chip
                            key={value}
                            label={value}
                            size="small"
                            onMouseDown={(e) => e.stopPropagation()}
                            onDelete={(e) => {
                              e.stopPropagation();
                              const updated = selected.filter(
                                (v) => v !== value,
                              );
                              handleChange({
                                target: {
                                  name: "Status",
                                  value: updated.join(","),
                                },
                              });
                            }}
                          />
                        ))}

                        {selected.length > 0 && (
                          <IconButton
                            sx={{ marginLeft: "10px" }}
                            size="small"
                            onMouseDown={(e) => e.stopPropagation()}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleChange({
                                target: { name: "Status", value: "" },
                              });
                            }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        )}
                      </Box>
                    )}
                  >
                    {[
                      "Inprogress",
                      "Completed",
                      "Approved",
                      "Rejected",
                      "Assigned",
                      "Not Yet Started",
                    ].map((status) => (
                      <MenuItem key={status} value={status}>
                        <Checkbox
                          checked={
                            values.Status
                              ? values.Status.split(",").includes(status)
                              : false
                          }
                        />
                        <ListItemText primary={status} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* From Date */}
                <TextField
                  name="fromDate"
                  type="date"
                  label="From Date"
                  variant="outlined"
                  focused
                  value={values.fromDate}
                  onBlur={handleBlur}
                  // onChange={handleChange}
                  onChange={(e) => {
                    handleChange(e);
                    sessionStorage.setItem("fromDate", e.target.value);
                  }}
                  sx={{ minWidth: 160 }}
                  InputLabelProps={{ shrink: true }}
                />

                {/* To Date */}
                <TextField
                  name="toDate"
                  type="date"
                  label="To Date"
                  variant="outlined"
                  focused
                  value={values.toDate}
                  onBlur={handleBlur}
                  // onChange={handleChange}
                  onChange={(e) => {
                    handleChange(e);
                    sessionStorage.setItem("toDate", e.target.value);
                  }}
                  sx={{ minWidth: 160 }}
                  InputLabelProps={{ shrink: true }}
                />

                {/* Page Break Checkbox */}
                <Tooltip title="Page Break" arrow>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={Pagebreakcheckbox}
                        onChange={(e) => {
                          setPagebreakcheckbox(e.target.checked);
                          sessionStorage.setItem(
                            "Pagebreakcheckbox",
                            e.target.checked,
                          );
                        }}
                      />
                    }
                    label="Page Break"
                  />
                </Tooltip>
                {/* Buttons */}
                <Box display="flex" gap={1}>
                  <Button type="submit" variant="contained" color="secondary">
                    APPLY
                  </Button>
                  <Button type="reset" variant="contained" color="error">
                    RESET
                  </Button>
                  {pdfEnabled ? (
                    <PDFDownloadLink
                      document={
                        Pagebreakcheckbox ? (
                          <PSRreportPageBreak_v1
                            data={safeAttendanceData}
                            projectName={projectName}
                            managerName={managerName}
                            filters={{
                              safeAttendanceData,
                              FromDate: values.fromDate,
                              ToDate: values.toDate,
                              EmployeeID: EMPNAME,
                              Imageurl: baseurl1,
                              HeaderImg: HeaderImg,
                              FooterImg: FooterImg,
                            }}
                            employeeTaskData={EmployeeTasksData}
                            projectTaskData={LisOfProjectData}
                            footerHeight={footerHeight}
                          />
                        ) : (
                          <PSRreport
                            data={safeAttendanceData}
                            projectName={projectName}
                            managerName={managerName}
                            filters={{
                              FromDate: values.fromDate,
                              ToDate: values.toDate,
                              EmployeeID: [
                                // ...(useCurrentEmp ? [EMPNAME] : []),

                                EMPNAME,
                                ...(selectedemployee?.map((emp) => emp.Name) ||
                                  []),
                              ].join(", "),
                              //   ...(selectedemployee?.map((emp) => emp.Name) || []),
                              // ].join(", "),
                              Imageurl: baseurl1,
                              HeaderImg: HeaderImg,
                              FooterImg: FooterImg,
                            }}
                            employeeTaskData={EmployeeTasksData}
                            projectTaskData={LisOfProjectData}
                            footerHeight={footerHeight}
                          />
                        )
                      }
                      fileName={`PR_Report_${useCurrentEmp
                        ? EMPNAME
                        : selectedemployee?.map((emp) => emp.Name).join(", ") ||
                        "Employee"
                        }.pdf`}
                      style={{ color: "#d32f2f", cursor: "pointer" }}
                    >
                      {({ loading }) =>
                        loading ? (
                          <PictureAsPdfIcon sx={{ fontSize: 24, opacity: 0.5 }} />
                        ) : (
                          <PictureAsPdfIcon sx={{ fontSize: 24 }} />
                        )
                      }
                    </PDFDownloadLink>
                  ) : (
                    <PictureAsPdfIcon
                      sx={{
                        fontSize: 24,
                        opacity: 0.4,
                        color: "#9e9e9e",
                        cursor: "not-allowed",
                      }}
                    />
                  )}
                  <FaFileExcel
                    size={20}
                    color="#1D6F42"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (!Array.isArray(safeAttendanceData) || !safeAttendanceData.length) {
                        alert("No data available to export");
                        return;
                      }

                      if (Pagebreakcheckbox) {
                        PSRreportPageBreakExcel(
                          safeAttendanceData,
                          {
                            FromDate: values.fromDate,
                            ToDate: values.toDate,
                            EmployeeID: EMPNAME,
                          },
                          projectName,
                          managerName,
                          EmployeeTasksData,
                          LisOfProjectData
                        );
                      } else {
                        console.log("--calling PSR Report WO PB");

                        PSRreportExcel(
                          safeAttendanceData,
                          {
                            FromDate: values.fromDate,
                            ToDate: values.toDate,
                            EmployeeID: [
                              EMPNAME,
                              ...(selectedemployee?.map(emp => emp.Name) || []),
                            ].join(", "),
                          },
                          projectName,
                          managerName,
                          EmployeeTasksData,
                          LisOfProjectData
                        );
                      }
                    }}
                  />

                  {/* 
 <FaFileExcel
  size={20}
  color="#1D6F42"
  style={{ cursor: "pointer" }}
  onClick={() => 
      PSRreportExcel(
        safeAttendanceData,
        {
          FromDate: values.fromDate,
          ToDate: values.toDate,
          EmployeeID: [
            EMPNAME,
            ...(selectedemployee?.map(emp => emp.Name) || []),
          ].join(", "),
        },
        projectName,
        managerName,
        EmployeeTasksData,
        LisOfProjectData
      )
        }
/>  */}
                </Box>
              </Box>
              {/*=== CHARTS SECTION === */}
              {/* <Box sx={{ mt: 3, mb: 3 }}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={4}>
                    <Paper sx={{ p: 2 }}>
                      <Typography variant="subtitle1" mb={1}>
                        Status Summary
                      </Typography>
                      <Pie data={pieData} />
                    </Paper>
                  </Grid>

                  <Grid item xs={12} md={8}>
                    <Paper sx={{ p: 2 }}>
                      <Typography variant="subtitle1" mb={1}>
                        Monthly Task Count
                      </Typography>
                      <Bar data={barData}
                        options={{
                          plugins: {
                            legend: { display: false }
                          }
                        }}
                      />
                    </Paper>
                  </Grid>
                </Grid>
              </Box> */}
              {/* {!hasApplied && (
                <Box sx={{ textAlign: "center", mt: 5 }}>
                  <Typography variant="h6" color="text.secondary">
                    Click APPLY to view report
                  </Typography>
                </Box>
              )} */}



              {hasApplied && (
                <>

                  <Box sx={{ marginVertical: 2, padding: 1 }}>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                      <Typography variant="h5"
                        sx={{
                          display: "flex",
                          // justifyContent: "center", 
                          fontSize: "18px",
                          fontWeight: "600"
                        }}>
                        Task Summary
                      </Typography>

                      {/* <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        Total Tasks: {totals.TotalTasks || 0}
                      </Typography> */}
                    </Box>

                    <Grid container spacing={2}>
                      <Grid item xs={12} md={2}>
                        <SummaryCard
                          title="Total Tasks"
                          value={totals.TotalTasks}
                          percent={100}
                          color="#607d8b"
                        />
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <SummaryCard
                          title="Completed"
                          value={totals.Completed}
                          percent={getPercent(totals.Completed)}
                          color="#4caf50"
                          loading={barLoading}
                        />
                      </Grid>

                      <Grid item xs={12} md={2}>
                        <SummaryCard
                          title="In Progress"
                          value={totals.InProgress}
                          percent={getPercent(totals.InProgress)}
                          color="#2196f3"
                          loading={barLoading}
                        />
                      </Grid>

                      <Grid item xs={12} md={2}>
                        <SummaryCard
                          title="Approved"
                          value={totals.Approved}
                          percent={getPercent(totals.Approved)}
                          color="#9c27b0"
                          loading={barLoading}
                        />
                      </Grid>

                      <Grid item xs={12} md={2}>
                        <SummaryCard
                          title="Back Logs"
                          value={totals.BackLog}
                          percent={getPercent(totals.BackLog)}
                          color="#f44336"
                          loading={barLoading}
                        />
                      </Grid>

                      <Grid item xs={12} md={2}>
                        <SummaryCard
                          title="Transferred"
                          value={totals.Transfered}
                          percent={getPercent(totals.Transfered)}
                          color="#ff9800"
                        />
                      </Grid>
                    </Grid>
                  </Box>


                  <Grid container spacing={3} sx={{ marginVertical: 2, padding: 1 }}>
                    {/* Pie */}
                    {/* <Grid item xs={12} md={4}>
                      <Paper
                        sx={{
                          p: 2,
                          height: 450,
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Typography
                          variant="h5"
                          mb={1}
                          sx={{
                            display: "flex",
                            // justifyContent: "center", 
                            fontSize: "18px",
                            fontWeight: "600"
                          }}                        >
                          Overall Summary
                        </Typography>

                        <Box
                          sx={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {pieLoading ? (
                            <CircularProgress />
                          ) : employees.length === 0 ? (
                            <Typography>No Data Available</Typography>
                          ) : (
                            <Pie
                              data={pieData}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false,
                              }}
                            />
                          )}
                        </Box>
                      </Paper>
                    </Grid> */}
                    <Grid item xs={12} md={6}>
                      <Paper
                        sx={{
                          p: 2,
                          height: 450,
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Typography
                          variant="h5"
                          mb={1}
                          sx={{
                            fontSize: "18px",
                            fontWeight: "600",
                          }}
                        >
                          Top Personnel By Effort Overrun
                        </Typography>

                        <Typography variant="h6" color="text.secondary" mb={1}>
                          Actual hours exceeding estimate
                        </Typography>

                        <Box
                          sx={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {hasEmployeeOverrunData === 0 ? (
                            <Typography>No Data Available</Typography>
                          ) : (
                            <Bar data={overrunBarData} options={overrunBarOptions} />
                          )}
                        </Box>
                      </Paper>
                    </Grid>
                    {/* Bar */}
                    <Grid item xs={12} md={6}>
                      <Paper
                        sx={{
                          p: 2,
                          height: 450,
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Typography
                          variant="h5"
                          mb={1}
                          sx={{
                            display: "flex",
                            // justifyContent: "center", 
                            fontSize: "18px",
                            fontWeight: "600"
                          }}                        >
                          Project Wise Split-Up
                        </Typography>

                        <Box
                          sx={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {barLoading ? (
                            <CircularProgress />
                          ) : ProjectsBar.length === 0 ? (
                            <Typography>No Data Available</Typography>
                          ) : (
                            <Bar
                              data={barData}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                indexAxis: "y",
                                // plugins: { legend: { display: false } },
                                plugins: {
                                  legend: {
                                    display: true,
                                    position: "top", // top | bottom | left | right
                                  },
                                },
                                scales: {
                                  x: {
                                    stacked: true,
                                    grid: { display: false },
                                    // ticks: {
                                    //   maxRotation: 45,
                                    //   minRotation: 45,
                                    // },
                                  },
                                  y: {
                                    stacked: true,
                                    // beginAtZero: true,
                                    grid: { display: false },
                                  },
                                },
                              }}
                            />
                          )}
                        </Box>
                      </Paper>
                    </Grid>


                  </Grid>
                  {/* <Grid container sx={{ marginVertical: 2, padding: 1 }}>
                    <Grid item xs={12} md={12}>
                      <Paper
                        sx={{
                          p: 2,
                          height: 400,
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >

                        <Typography variant="h6" fontWeight={600}>
                          Product costing
                        </Typography>

                        <Typography variant="caption" color="text.secondary" mb={1}>
                          Estimated vs actual hours per project
                        </Typography>

                        <Box sx={{ flex: 1 }}>
                          {hasProductCostingData ? (
                            <Bar data={costingBarData} options={costingBarOptions} />
                          ) : (
                            <Typography variant="h6" color="text.secondary">
                              No Data Available
                            </Typography>
                          )}
                        </Box>
                      </Paper>
                    </Grid>
                  </Grid> */}

                  <Box sx={{ marginVertical: 2, padding: 1 }}>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                      <Typography variant="h5"
                        sx={{
                          display: "flex",
                          // justifyContent: "center", 
                          fontSize: "18px",
                          fontWeight: "600"
                        }}>
                        Costing Summary
                      </Typography>

                      {/* <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        Total Tasks: {totals.TotalTasks || 0}
                      </Typography> */}
                    </Box>

                    {/* <Grid container spacing={2}>

                      <Grid item xs={12} md={3}>
                        <CostingSummaryCard
                          title="Budget"
                          subHeading="Total project budget"
                          value={totals.Completed}
                          percent={getPercent(totals.Completed)}
                          color="#9c27b0"
                        />
                      </Grid>

                      <Grid item xs={12} md={3}>
                        <CostingSummaryCard
                          title="Scheduled Cost"
                          subHeading="Planned spend to date"
                          value={totals.InProgress}
                          percent={getPercent(totals.InProgress)}
                          color="#2196f3"
                        />
                      </Grid>

                      <Grid item xs={12} md={3}>
                        <CostingSummaryCard
                          title="Actual Cost"
                          subHeading="Actual spend to date"
                          value={totals.Approved}
                          percent={getPercent(totals.Approved)}
                          color="#4caf50"
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <CostingSummaryCard
                          title="Other Expenses"
                          subHeading="Additional project costs"
                          value={totals.Transfered}
                          percent={getPercent(totals.Transfered)}
                          color="#ff9800"
                        />
                      </Grid>
                    </Grid> */}

                    <Grid container spacing={2}>
                      {costingSummary.map((item, index) => {

                        const colorMap = {
                          "Budget": "#9c27b0",
                          "Scheduled Cost": "#2196f3",
                          "Actual Cost": "#4caf50",
                          "Other Expenses": "#ff9800",
                        };

                        return (
                          <Grid item xs={12} md={3} key={index}>
                            <CostingSummaryCard
                              title={item.Label}
                              subHeading={item.Hint}
                              value={item.Value}
                              percent={item.Percentage}
                              color={colorMap[item.Label] || "#607d8b"}
                              loading={CostOverviewLoading}
                            />
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Box>
                  <Grid container spacing={3} sx={{ marginVertical: 2, padding: 1 }}>

                    <Grid item xs={12} md={6}>
                      <Paper
                        sx={{
                          p: 2,
                          height: 500,
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >

                        <Typography
                          variant="h5"
                          mb={1}
                          sx={{
                            display: "flex",
                            // justifyContent: "center", 
                            fontSize: "18px",
                            fontWeight: "600"
                          }}                        >
                          Project Costing
                        </Typography>
                        {/* <Typography variant="h6" fontWeight={600}>
                          Product costing
                        </Typography> */}

                        <Typography variant="h6" color="text.secondary" mb={1}>
                          Estimated vs Actual hrs per project
                        </Typography>

                        <Box sx={{ flex: 1 }}>
                          {hasProductCostingData ? (
                            <Bar data={costingBarData} options={costingBarOptions} />
                          ) : (
                            <Typography variant="h6" color="text.secondary">
                              No Data Available
                            </Typography>
                          )}
                        </Box>
                      </Paper>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Paper sx={{ p: 2, height: 500, }}>
                        <Typography
                          variant="h5"
                          mb={1}
                          sx={{
                            display: "flex",
                            // justifyContent: "center", 
                            fontSize: "18px",
                            fontWeight: "600"
                          }}                        >
                          Cost Overview
                        </Typography>

                        <Typography variant="h6" color="text.secondary">
                          Budget vs Scheduled vs Actual vs Other per project
                        </Typography>

                        <Box sx={{ height: "85%" }}>
                          {hasCostOverviewData ? (
                            <Bar data={costOverviewData} options={costOverviewOptions} />
                          ) : (
                            <Typography variant="h6" color="text.secondary">
                              No Data Available
                            </Typography>
                          )}
                        </Box>
                      </Paper>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <Paper
                        sx={{
                          p: 2,
                          height: 500,
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Typography
                          variant="h5"
                          mb={1}
                          sx={{
                            display: "flex",
                            // justifyContent: "center", 
                            fontSize: "18px",
                            fontWeight: "600"
                          }}
                        >
                          Cost Trends
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: "13px",
                            color: "#6b7280",
                            mb: 1,
                          }}
                        >
                          Monthly Cumulative Scheduled vs Actual Spend — per project
                        </Typography>

                        <Box sx={{ height: 250 }}>
                          {hasCostTrendData ? (
                            <Line data={costTrendData} options={costTrendOptions} />
                          ) : (<Typography variant="h6" color="text.secondary">
                            No Data Available
                          </Typography>)}
                        </Box>

                        {/* Summary Section */}
                        <Box mt={1}>
                          {/* Header */}
                          <Box
                            sx={{
                              display: "grid",
                              gridTemplateColumns: "2fr 1fr 1fr 1.2fr",
                              fontSize: "11px",
                              color: "#888",
                              borderBottom: "1px solid #eee",
                              pb: 0.7,
                              mb: 0.5,
                              fontWeight: 500,
                            }}
                          >
                            <Typography>PROJECT</Typography>
                            <Typography align="right">SCHEDULED ({lastMonth})</Typography>
                            <Typography align="right">ACTUAL ({lastMonth})</Typography>
                            <Typography align="right">STATUS ({lastMonth})</Typography>
                          </Box>

                          {/* Rows */}
                          {projects.map((proj, index) => {
                            const kpi = proj.KPI;

                            return (
                              <Box
                                key={index}
                                sx={{
                                  display: "grid",
                                  gridTemplateColumns: "2fr 1fr 1fr 1.2fr",
                                  alignItems: "center",
                                  py: 0.8,
                                  fontSize: "13px",
                                  borderBottom:
                                    index !== projects.length - 1 ? "1px solid #f5f5f5" : "none",
                                  "&:hover": {
                                    backgroundColor: "#fafafa",
                                  },
                                }}
                              >
                                {/* Project */}
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                  <Box
                                    sx={{
                                      width: 8,
                                      height: 8,
                                      borderRadius: "50%",
                                      backgroundColor:
                                        proj.KPI?.DotColor || proj.Colors?.Scheduled,
                                      mr: 1,
                                    }}
                                  />
                                  <Typography fontSize="13px">
                                    {proj.ProjectName}
                                  </Typography>
                                </Box>

                                {/* Scheduled */}
                                <Typography align="right" fontSize="13px">
                                  {kpi?.ScheduledDisplay}
                                </Typography>

                                {/* Actual */}
                                <Typography align="right" fontSize="13px">
                                  {kpi?.ActualDisplay}
                                </Typography>

                                {/* Status */}
                                <Box textAlign="right">
                                  <Typography
                                    sx={{
                                      fontWeight: 600,
                                      fontSize: "12px",
                                      color: kpi?.Color,
                                    }}
                                  >
                                    {kpi?.VarianceText}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontSize: "11px",
                                      color: kpi?.Color,
                                    }}
                                  >
                                    {kpi?.VariancePctText}
                                  </Typography>
                                </Box>
                              </Box>
                            );
                          })}
                        </Box>
                      </Paper>
                    </Grid>
                  </Grid>
                </>
              )}

              {/* <Box
                display="grid"
                gridTemplateColumns="repeat(2, minmax(0, 1fr))"
                gap={formGap}
                padding={1}
                sx={{
                  "& > div": {
                    gridColumn: isNonMobile ? undefined : "span 4",
                  },
                }}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  gap={2}
                  sx={{ flexWrap: "wrap", gridColumn: "span 2" }}
                >
                  <Box sx={{ minWidth: 230 }}>
                   
                    <MultiFormikOptimizedAutocomplete
  sx={{ width: "100%" }}
  name="ProName"
  label="Project"
  id="ProName"
  value={selectedPro}
  onChange={(e, newValue) => {
    setFieldValue("block", newValue);
    setSelectedPro(newValue);

    
const projecIDfilter = newValue.map((ProName) => ProName.RecordID).join(",");

    // Step: Create the full employee URL
    const fullURL = `${listViewurl}?data=${encodeURIComponent(
      JSON.stringify({
        Query: {
          AccessID: "2115",
          ScreenName: "EMPLOYEETEAMS",
          // Filter: `ProjectID IN(${projecIDfilter})`,
         Filter: `ProjectID IN(${projecIDfilter}) AND CompanyID='${companyID}' GROUP BY RecordID`,
          Any: "",
          CompId: companyID,
        },
      })
    )}`;

    // Step: Update employee URL state
    setEmployeeURL(fullURL);
  }}
  url={`${listViewurl}?data=${encodeURIComponent(
    JSON.stringify({
      Query: {
        AccessID: "2114",
        ScreenName: "Project",
        Filter: `parentID=${companyID} AND EmployeeID=${EMPID}`,
        Any: "",
      },
    })
  )}`}
/>

                  </Box>
                  {isManager == "1" && (
                      <Box sx={{ minWidth: 230 }}>
                    
                       <MultiFormikOptimizedAutocomplete
      sx={{ width: "100%" }}
      name="Employee"
      label="Employee"
      id="Employee"
      value={selectedemployee}
      onChange={(e, newValue) => {
        setFieldValue("Employee", newValue);
        setSelectedEmployee(newValue);

        if (
          newValue.length > 0 &&
          !(newValue.length === 1 && newValue[0].RecordID === EMPID)
        ) {
          setUseCurrentEmp(false);
        }
      }}
      url={employeeURL} // ✅ dynamic url based on project selection
    />
                     
                    </Box>
                  )}
                  <TextField
                    name="fromDate"
                    type="date"
                    id="fromDate"
                    label="From Date"
                    variant="outlined"
                    focused
                    format="MM-DD-YYYY"
                    value={values.fromDate}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.fromDate && !!errors.fromDate}
                    helperText={touched.fromDate && errors.fromDate}
                    sx={{
                      minWidth: 200,
                      height: 56,
                      marginTop: 1.5,
                      "& .MuiInputBase-root": {
                        height: "70%", // sets height of input box
                      },
                    }}
                  />
                  <TextField
                    name="toDate"
                    type="date"
                    id="toDate"
                    label="To Date"
                    variant="outlined"
                    focused
                    format="MM-DD-YYYY"
                    value={values.toDate}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.toDate && !!errors.toDate}
                    helperText={touched.toDate && errors.toDate}
                    sx={{
                      minWidth: 200,
                      height: 56,
                      marginTop: 1.5,
                      "& .MuiInputBase-root": {
                        height: "70%", // sets height of input box
                      },
                    }}
                />
                  <FormControlLabel
                    control={
                      <Field
                        // type="checkbox"
                        // name="checkbox7"
                        as={Checkbox}
                        checked={Pagebreakcheckbox}
                        onChange={(e) => {
                          //  const isChecked = e.target.checked;
                          setPagebreakcheckbox(e.target.checked);
                        }}
                      />
                    }
                    label="Page Break"
                  />
                </Box>
               
              </Box>

              <Box
                mt={-2}
                display="flex"
                justifyContent="end"
                padding={1}
                gap={formGap}
              >
                <Button type="submit" variant="contained" color="secondary">
                  APPLY
                </Button>
                <Button type="reset" variant="contained" color="error">
                  RESET
                </Button>
              
                <PDFDownloadLink
                  document={
                    Pagebreakcheckbox == true ? (
                      <PSRreportPageBreak_v1
                        data={safeAttendanceData}
                        projectName={projectName}
                        managerName={managerName}
                        filters={{
                          safeAttendanceData: safeAttendanceData,
                          FromDate: values.fromDate,
                          ToDate: values.toDate,
                          EmployeeID: EMPNAME,
                        }}
                        employeeTaskData={EmployeeTasksData}
                        projectTaskData={LisOfProjectData}
                      />
                    ) : (
                     
                      <PSRreport
                        data={safeAttendanceData}
                        projectName={projectName}
                        managerName={managerName}
                        filters={{
                          FromDate: values.fromDate,
                          ToDate: values.toDate,
                          EmployeeID: [
                            ...(useCurrentEmp ? [EMPNAME] : []),
                            ...(selectedemployee?.map((emp) => emp.Name) || []),
                          ].join(", "),
                        
                        }}
                          employeeTaskData={EmployeeTasksData}
                        projectTaskData={LisOfProjectData}
                      />
                    )
                  }
                  fileName={`PSR_Report_${
                    useCurrentEmp
                      ? EMPNAME
                      : selectedemployee?.map((emp) => emp.Name).join(", ") ||
                        "Employee"
                  }.pdf`}
                  style={{ color: "#d32f2f", cursor: "pointer" }} // Red for PDF feel
                >
                  {({ loading }) =>
                    loading ? (
                      <PictureAsPdfIcon sx={{ fontSize: 24, opacity: 0.5 }} />
                    ) : (
                      <PictureAsPdfIcon sx={{ fontSize: 24 }} />
                    )
                  }
                </PDFDownloadLink>
              </Box> */}


              {hasApplied && (
                <Box sx={{ gridColumn: "span 4" }}>

                  <Grid container sx={{ marginVertical: 2 }}>
                    <Grid item xs={12} md={12}>
                      <Box
                        height="450px"
                        // height={dataGridHeight}
                        margin={1}
                        sx={{
                          "& .MuiDataGrid-root": {
                            // border: "none",
                          },
                          "& .MuiDataGrid-cell": {
                            // borderBottom: "none",
                          },
                          "& .name-column--cell": {
                            color: colors.greenAccent[300],
                          },
                          "& .MuiDataGrid-columnHeaders": {
                            backgroundColor: colors.blueAccent[800],
                            // borderBottom: "none",
                          },
                          "& .MuiDataGrid-virtualScroller": {
                            backgroundColor: colors.primary[400],
                          },
                          "& .MuiDataGrid-footerContainer": {
                            // borderTop: "none",
                            backgroundColor: colors.blueAccent[800],
                          },
                          "& .MuiCheckbox-root": {
                            color: `${colors.greenAccent[200]} !important`,
                          },
                          "& .odd-row": {
                            backgroundColor: "",
                            color: "", // Color for odd rows
                          },
                          "& .even-row": {
                            backgroundColor: "#d0edec",
                            color: "", // Color for even rows
                          },
                        }}
                      >
                        <DataGrid
                          sx={{
                            "& .MuiDataGrid-footerContainer": {
                              height: dataGridHeaderFooterHeight,
                              minHeight: dataGridHeaderFooterHeight,
                            },
                          }}
                          rowHeight={dataGridRowHeight}
                          headerHeight={dataGridHeaderFooterHeight}
                          rows={PSRData}
                          columns={PSRTaskColumn}
                          disableSelectionOnClick
                          getRowId={(row) => row.RecordID}
                          pageSize={pageSize}
                          page={page}
                          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                          onPageChange={(newPage) => setPage(newPage)}
                          onCellClick={(params) => { }}
                          rowsPerPageOptions={[5, 10, 15, 20]}
                          pagination
                          components={{
                            Toolbar: AttendanceTool,
                          }}
                          onStateChange={(stateParams) =>
                            setRowCount(stateParams.pagination.rowCount)
                          }
                          loading={PSRLoading}
                          componentsProps={{
                            toolbar: {
                              showQuickFilter: true,
                              quickFilterProps: { debounceMs: 500 },
                            },
                          }}
                          getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0
                              ? "odd-row"
                              : "even-row"
                          }
                        />
                      </Box>
                    </Grid>
                  </Grid>
                  {/* Employee Datagrid */}

                  <Grid container sx={{ marginVertical: 2 }}>
                    <Grid item xs={12} md={6}>
                      <Box
                        height="450px"
                        // height={dataGridHeight}
                        //marginTop={2}
                        margin={1}
                        sx={{
                          "& .MuiDataGrid-root": {
                            // border: "none",
                          },
                          "& .MuiDataGrid-cell": {
                            // borderBottom: "none",
                          },
                          "& .name-column--cell": {
                            color: colors.greenAccent[300],
                          },
                          "& .MuiDataGrid-columnHeaders": {
                            backgroundColor: colors.blueAccent[800],
                            // borderBottom: "none",
                          },
                          "& .MuiDataGrid-virtualScroller": {
                            backgroundColor: colors.primary[400],
                          },
                          "& .MuiDataGrid-footerContainer": {
                            // borderTop: "none",
                            backgroundColor: colors.blueAccent[800],
                          },
                          "& .MuiCheckbox-root": {
                            color: `${colors.greenAccent[200]} !important`,
                          },
                          "& .odd-row": {
                            backgroundColor: "",
                            color: "", // Color for odd rows
                          },
                          "& .even-row": {
                            backgroundColor: "#d0edec",
                            color: "", // Color for even rows
                          },
                        }}
                      >
                        <DataGrid
                          sx={{
                            "& .MuiDataGrid-footerContainer": {
                              height: dataGridHeaderFooterHeight,
                              minHeight: dataGridHeaderFooterHeight,
                            },
                          }}
                          rowHeight={dataGridRowHeight}
                          headerHeight={dataGridHeaderFooterHeight}
                          rows={PSRempTaskData}
                          columns={PSRempTaskColumn}
                          disableSelectionOnClick
                          getRowId={(row) => row.RecordID}
                          pageSize={pageSize}
                          page={page1}
                          onPageChange={(newPage) => setPage1(newPage)}
                          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                          onCellClick={(params) => { }}
                          rowsPerPageOptions={[5, 10, 15, 20]}
                          pagination
                          components={{
                            Toolbar: EmployeeTasks,
                          }}
                          onStateChange={(stateParams) =>
                            setRowCount(stateParams.pagination.rowCount)
                          }
                          loading={PSRLoading}
                          componentsProps={{
                            toolbar: {
                              showQuickFilter: true,
                              quickFilterProps: { debounceMs: 500 },
                            },
                          }}
                          getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0
                              ? "odd-row"
                              : "even-row"
                          }
                        />
                      </Box>
                    </Grid>
                    {/*Project grid */}
                    <Grid item xs={12} md={6}>
                      <Box
                        height="450px"
                        // height={dataGridHeight}
                        //marginTop={2}
                        margin={1}
                        sx={{
                          "& .MuiDataGrid-root": {
                            // border: "none",
                          },
                          "& .MuiDataGrid-cell": {
                            // borderBottom: "none",
                          },
                          "& .name-column--cell": {
                            color: colors.greenAccent[300],
                          },
                          "& .MuiDataGrid-columnHeaders": {
                            backgroundColor: colors.blueAccent[800],
                            // borderBottom: "none",
                          },
                          "& .MuiDataGrid-virtualScroller": {
                            backgroundColor: colors.primary[400],
                          },
                          "& .MuiDataGrid-footerContainer": {
                            // borderTop: "none",
                            backgroundColor: colors.blueAccent[800],
                          },
                          "& .MuiCheckbox-root": {
                            color: `${colors.greenAccent[200]} !important`,
                          },
                          "& .odd-row": {
                            backgroundColor: "",
                            color: "", // Color for odd rows
                          },
                          "& .even-row": {
                            backgroundColor: "#d0edec",
                            color: "", // Color for even rows
                          },
                        }}
                      >
                        <DataGrid
                          sx={{
                            "& .MuiDataGrid-footerContainer": {
                              height: dataGridHeaderFooterHeight,
                              minHeight: dataGridHeaderFooterHeight,
                            },
                          }}
                          rowHeight={dataGridRowHeight}
                          headerHeight={dataGridHeaderFooterHeight}
                          rows={PSRprojectTaskData}
                          columns={PSRprojectColumn}
                          disableSelectionOnClick
                          getRowId={(row) => row.ProjectID}
                          pageSize={pageSize}
                          page={page2}
                          onPageChange={(newPage) => setPage2(newPage)}
                          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                          onCellClick={(params) => { }}
                          rowsPerPageOptions={[5, 10, 15, 20]}
                          pagination
                          components={{
                            Toolbar: ProjectTool,
                          }}
                          onStateChange={(stateParams) =>
                            setRowCount(stateParams.pagination.rowCount)
                          }
                          loading={PSRLoading}
                          componentsProps={{
                            toolbar: {
                              showQuickFilter: true,
                              quickFilterProps: { debounceMs: 500 },
                            },
                          }}
                          getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0
                              ? "odd-row"
                              : "even-row"
                          }
                        />
                      </Box>

                    </Grid>
                  </Grid>
                </Box>
              )}
            </form>
          )}
        </Formik>
        {/* </Box> */}
      </Paper>
    </React.Fragment>
  );
};

export default EditProjectStatusReport;
